import apiClient from '../apiClient';
import { GET_COUNTRY_LIST_URL } from '../apiUrl';

const getCountryListApi = () => {
  return apiClient.get(GET_COUNTRY_LIST_URL);
};

export default getCountryListApi;
